import request from '@/utils/request'

export function getMadrakInfo() {
  return request({
    url: 'madrak/data',
    method: 'post'
  })
}

export function getMadrakAll() {
  return request({
    url: 'madrak/all',
    method: 'post'
  })
}


export function requestMadrak(file, sath, comment) {
  let fileName = file == null ? "" : file.name
  var fmData = new FormData();


  fmData.append('Sath', sath)
  fmData.append('Comment', comment)
  fmData.append('image', file)
  fmData.append('fileName', fileName)

  return request({
    url: 'madrak/save',
    method: 'post',
    data: fmData

  })
}
export function getMadrakHistory() {
  return request({
    url: 'madrak/gethistory',
    method: 'post'
  })
}

export function removeMadrakRequest(requestID) {
  return request({
    url: 'madrak/remove',
    method: 'post',
    data: { requestID: requestID }
  })
}

export function downloadAttach(requestID, step, token) {
  return request({
    url: '/madrak/downloadattach',
    method: 'post',

    data: { RequestID: requestID, Step: step, HashToken: token }
  })

}










